import { render, staticRenderFns } from "./index-pc.vue?vue&type=template&id=0e2f63c2&scoped=true&"
import script from "./index-pc.vue?vue&type=script&lang=js&"
export * from "./index-pc.vue?vue&type=script&lang=js&"
import style0 from "./index-pc.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./index-pc.vue?vue&type=style&index=1&id=0e2f63c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2f63c2",
  null
  
)

export default component.exports